import React from 'react';
import { PatientService, ServicesContext } from '~/services';
import { useServiceSubscribe } from '~/util';

export function useSubmissionUploads(
    patient: PatientType,
    submissionsObj: string,
    gapType: number,
    setUploads: (x: MediaFileType[]) => void,
    setLoading: (x: boolean) => void
) {
    const servicesContext = React.useContext(ServicesContext);
    const submission = React.useRef<null | PatientSubmissionType>(null);

    const getUploads = React.useCallback(async () => {
        if (!submission.current?.id) {
            setUploads([]);
        } else {
            setLoading(true);
            const result = await servicesContext.patient.loadSubmission(submission.current.id);
            submission.current = result;
            setUploads(result.media);
            setLoading(false);
        }
    }, [setLoading, setUploads, servicesContext.patient]);

    React.useEffect(() => {
        const found = patient.submissions.find((x) => x.gap_type === gapType);
        if (found?.id !== submission.current?.id) {
            submission.current = found || null;
            getUploads();
        }
    }, [gapType, getUploads, patient.submissions, submissionsObj]);
    useServiceSubscribe(PatientService.EVENTS.uploads_updated, getUploads);

    return submission.current;
}
